import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { CentaurTableOverflowTitleService } from './centaur-table-overflow-title.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private _centaurTableOverflowTitleService = inject(
    CentaurTableOverflowTitleService,
  );
}
